export default {
    label_task:{
        en:"Distributors",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Distributor",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Distributor",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Distributor",
        bn:'ব্যবহারকারীর বিবরণ'
    },

}